import MegaMenu from './components/megaMenu';
//import './components/megaMenuMobile';
document.addEventListener('DOMContentLoaded', () => {
  document.body.classList.remove('no-js');
  document.body.classList.add('has-js');

  const navElement = document.querySelector('.mod_megamenu');
  const bpMenuMin = '(min-width: 980px)';

  if (window.matchMedia(bpMenuMin).matches && navElement) {
    const menuWrappers = navElement.querySelectorAll('li.mega-menu');

    menuWrappers.forEach((menuWrapper) => {
      new MegaMenu(menuWrapper);
    });
  }
});
